.productCard {
  cursor: pointer;

  .imageWrapper {
    position: relative;
    overflow: hidden;
  }
  .image {
    object-fit: cover;
    transition: transform 0.2s;
  }
  &:hover {
    .image {
      transform: scale(1.05);
    }
  }
}
